import { forwardRef } from "react";
import logo from "@/assets/cashisle-logo.png";
import { cn } from "@/lib/utils";

interface Props {
  className?: string;
  size?: number;
}

export const CashIsleLogo = forwardRef<HTMLImageElement, Props>(
  ({ className, size = 56 }, ref) => (
    <img
      ref={ref}
      src={logo}
      alt="Cash Isle logo"
      width={size}
      height={size}
      className={cn("object-contain select-none", className)}
      draggable={false}
    />
  )
);
CashIsleLogo.displayName = "CashIsleLogo";
